//export const API_URL = 'http://localhost:3000/api/';
export const API_URL = 'https://api.nfcero.com/api/';
//export const API_URL = 'https://api-dev.nfcero.com/api/';
export const BASE_URL = 'https://nfcero.com/';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyBeZI7OsU3PoEkoZxzBfOhj1Wwlmpx8knQ';